import React, { Fragment } from 'react';
import config from 'client/shared/config';

import { NavLink } from 'react-router-dom';
import Carousel from 'react-multi-carousel';

class ListCarousel extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate (nextProps, nextState) {
        return false;
	}
    render () {
        const {artists, responsiveBreakpoints, hideFunc} = this.props;
        console.log(artists);

        return (
            <Carousel
                className="margin-bottom-3"
                arrows={true}
                swipeable={true}
                draggable={true}
                infinite={false}
                additionalTransfrom={10}
                responsive={responsiveBreakpoints}
                deviceType="desktop"
                partialVisible={false}
                itemClass="carouselement"
            >
                {
                    // Playlist have all the data they need to render the list item, no need for the artist store
                    artists.map(({ _id: id, name, genre, profileImage, isExclusive }) => {
                        const exclusiveClass = isExclusive ? 'mzd-exclusive-artist' : '';
                        
                        return (
                            <div key={ id } className="carousel-element cell shrink padding-top-1 padding-right-1 padding-bottom-1 text-center">
                                <NavLink
                                    onClick={hideFunc}
                                    className={`image medium ${exclusiveClass}`}
                                    to={ `/artist/${id}/tracks` }
                                    style={
                                        {
                                            display: 'block',   
                                            backgroundImage: `url("${config.paths.profileImgBasePath}/${profileImage}")`,
                                            width: '14.15em',
                                            height: '14.15em',
                                            boxShadow: 'rgba(0, 0, 0, 0.8) 0px 0px 11px'
                                        }
                                    }>
                                </NavLink>
                                <div className="margin-top-1">
                                    <span style={{maxWidth:'11.5rem'}} className="carousel-label">{ name }
                                        <span style={{maxWidth:'11.5rem'}} className="carousel-label lite">{ genre }</span>
                                    </span>
                                </div>
                            </div>
                        )
                    })
                }
            </Carousel>
        )
    }
}

export default ListCarousel;
